import cn from 'classnames/bind';
import { Col, Container, Row, Text } from 'ui';
import BlogCard from 'ui/components/blog/BlogCard';
import Slider from 'ui/components/Slider';
import { getNewLabel } from 'utils';
import { dateformat } from 'utils/datetime';
import { getArticleHref } from 'utils/links';


import s from './ExploreBlogTypesMobileSection.module.scss';

const cx = cn.bind(s);

export const defaultColumnProps = {
  xs: 12,
  md: { span: 10, offset: 1 },
  lg: { offset: 0, span: 8 },
};
export default function ExploreBlogTypesMobileSection ({items, isLanding}) {
  return <div className={cx('exploreMobileBlock')}>
    <Container>
      <Row>
        <Col {...defaultColumnProps}>
          <Text as="h4"
            className={cx(
              'exploreMobileCard',
            )}
          >
          Explore this type
          </Text>
        </Col>
      </Row>
    </Container>
    <Slider
      className={cx('exploreMobileSlider')}
      slidesPerView="1"
      initialSlide={0}
      centeredSlides
    >
      {items.map((explorePost) => (
        <Container key={explorePost.title}>
          <Row>
            <Col {...defaultColumnProps}>
              <BlogCard
                isExtended={explorePost.isExtended}
                date={dateformat.short(
                  explorePost.createdAt || new Date(),
                )}
                label={getNewLabel(explorePost.createdAt)}
                href={getArticleHref(explorePost.slug, {
                  isLanding,
                })}
                external
                title={explorePost.title}
                text={explorePost.description}
                author={explorePost.author}
                poster={explorePost.image}
                posterMeta={explorePost.imageData}
              />
            </Col>
          </Row>
        </Container>
      ))}
    </Slider>
  </div>
}